import { AGENT_MODEL, TestMode } from '@nrwl/common-lib';
import {
  UDPConfigFieldMapping as ConfigFieldMapping,
  DEFAULT_STREAM_A2B,
  DEFAULT_STREAM_B2A,
  streamRateConventionValue
} from '../models/models';

export const UDP_AGENT_MODEL_CONFIG = {
  id: 'udp_test',
  agentConfig: {
    default: {
      setup: {
        //setup page model
        alias: {
          enabled: true,
          value: 'UDP',
          outputField: ConfigFieldMapping.ALIAS,
          tabId: 'udp_setup',
          restoreOnAgentChange: true
        },
        customer: {
          enabled: true,
          value: '',
          outputField: 'customer',
          tabId: 'udp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technician: {
          enabled: true,
          value: '',
          outputField: 'technician',
          tabId: 'udp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        contact: {
          enabled: true,
          value: '',
          outputField: 'contact',
          tabId: 'udp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        email: {
          enabled: true,
          value: '',
          outputField: 'email',
          tabId: 'udp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        phone: {
          enabled: true,
          value: '',
          outputField: 'phone',
          tabId: 'udp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technicianId: {
          enabled: true,
          value: '',
          outputField: 'technicianId',
          tabId: 'udp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        comments: {
          enabled: true,
          value: '',
          outputField: 'comments',
          tabId: 'udp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        runType: {
          enabled: true,
          value: 'on-going',
          outputField: ConfigFieldMapping.RUN_TYPE,
          tabId: 'udp_setup',
          restoreOnAgentChange: true
        },
        scheduler: {
          enabled: true,
          value: { repeatInterval: 0, timeStamp: '', endTime: 90, isValid: true },
          outputField: ConfigFieldMapping.SCHEDULER,
          tabId: 'udp_setup',
          restoreOnAgentChange: true
        },
        engineAInfo: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.ENGINE_A_INFO,
          tabId: 'udp_setup',
          restoreOnAgentChange: true
        },
        engineBInfo: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.ENGINE_B_INFO,
          tabId: 'udp_setup'
        },
        agentType: {
          enabled: true,
          value: 'default',
          outputField: ConfigFieldMapping.AGENT_TYPE,
          tabId: 'udp_setup'
        },
        testMode: {
          enabled: true,
          value: TestMode.CLIENT_TO_MA,
          outputField: ConfigFieldMapping.TEST_MODE,
          tabId: 'udp_setup',
          restoreOnAgentChange: true
        },
        direction: {
          enabled: true,
          value: TestMode.UNIDIRECIONAL_A_TO_B,
          outputField: ConfigFieldMapping.DIRECTION,
          tabId: 'udp_setup',
          restoreOnAgentChange: true
        },
        selectedOriginator: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SELECTED_ORIGINATOR,
          tabId: 'udp_setup',
          restoreOnAgentChange: true
        },
        selectedDestination: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SELECTED_DESTINATION,
          tabId: 'udp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        duration: {
          enabled: true,
          value: 900,
          outputField: ConfigFieldMapping.TEST_DURATION,
          tabId: 'udp_setup',
          restoreOnAgentChange: true
        },
        customTestDuration: {
          enabled: true,
          value: '00:15:00',
          outputField: ConfigFieldMapping.TEST_CUSTOM_DURATION,
          tabId: 'udp_setup',
          restoreOnAgentChange: true
        },
        streamRateConvention: {
          enabled: true,
          value: streamRateConventionValue.L2,
          outputField: ConfigFieldMapping.STREAM_RATE_CONVENTION,
          tabId: 'udp_setup',
          restoreOnAgentChange: true
        },
        vlan: {
          enabled: true,
          value: 46,
          outputField: ConfigFieldMapping.VLAN,
          tabId: 'udp_setup',
          restoreOnAgentChange: true
        },
        expirationTimeValue: {
          enabled: false,
          value: 24,
          outputField: ConfigFieldMapping.EXPIRATION_DEFAULT_VALUE,
          tabId: 'udp_setup'
        },
        expirationDate: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.EXPIRATION_DATE,
          tabId: 'udp_setup'
        },
        maxExecutionCounts: {
          enabled: false,
          value: 0,
          outputField: ConfigFieldMapping.MAX_EXECUTION_COUNTS,
          tabId: 'udp_setup'
        },
        shaId: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SHA_ID,
          tabId: 'udp_setup',
          outputOptional: true
        },
        streamsA2B: {
          enabled: true,
          value: DEFAULT_STREAM_A2B,
          outputField: ConfigFieldMapping.STREAMS_A2B,
          tabId: 'udp_streams',
          restoreOnAgentChange: true,
          outputOptional: true
        },
        streamsB2A: {
          enabled: true,
          value: DEFAULT_STREAM_B2A,
          outputField: ConfigFieldMapping.STREAMS_B2A,
          tabId: 'udp_streams',
          restoreOnAgentChange: true,
          outputOptional: true
        },
        maxServices: {
          enabled: true,
          value: 10,
          outputField: ConfigFieldMapping.MAX_SERVICES,
          tabId: 'udp_streams'
        },
        maxBandwidth: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.MAX_BANDWIDTH,
          tabId: 'udp_streams',
          outputOptional: true
        },
        validFrameSizes: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            frameList: [
              { label: 64, value: 64, enable: false },
              { label: 128, value: 128, enable: false },
              { label: 256, value: 256, enable: false },
              { label: 512, value: 512, enable: true },
              { label: 1024, value: 1024, enable: false },
              { label: 1280, value: 1280, enable: false },
              { label: 1518, value: 1518, enable: false },
              { label: 9000, value: 9000, enable: false },
              { label: 'custom', value: 300, enable: false }
            ],
            minValue: 64,
            maxValue: 9000,
            selectedVlans: 0
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZES,
          tabId: 'udp_streams'
        },
        framesSizes: {
          enabled: true,
          value: '512',
          outputField: ConfigFieldMapping.FRAME_SIZE,
          tabId: 'udp_streams',
          restoreOnAgentChange: true
        }
      },

      running: {
        add: 'anything that is different between agents in running view'
      },

      final: {
        add: 'anything that is different between agents in final report'
      },
      modes: {
        [TestMode.CLIENT_TO_MA]: {
          setup: {
            expirationTimeValue: { enabled: true },
            expirationDate: { enabled: true },
            maxExecutionCounts: { enabled: true },
            maxServices: { enabled: true, value: 5 },
            engineBInfo: { enabled: false }
          }
        },
        [TestMode.MA_TO_MA]: {
          setup: {
            maxServices: { enabled: true, value: 10 }
          }
        }
      }
    },
    [AGENT_MODEL.VTA_TS]: {
      modes: {
        [TestMode.CLIENT_TO_MA]: {
          setup: {
            expirationTimeValue: { enabled: true },
            expirationDate: { enabled: true },
            maxExecutionCounts: { enabled: true },
            maxServices: { enabled: true, value: 5 }
          }
        },
        [TestMode.MA_TO_MA]: {
          setup: {
            maxServices: { enabled: true, value: 10 },
            engineBInfo: { enabled: true }
          }
        }
      }
    },
    [AGENT_MODEL.VSPA_SAT_TS]: {
      modes: {
        [TestMode.CLIENT_TO_MA]: {
          setup: {
            expirationTimeValue: { enabled: true },
            expirationDate: { enabled: true },
            maxExecutionCounts: { enabled: true },
            maxServices: { enabled: true, value: 5 }
          }
        },
        [TestMode.MA_TO_MA]: {
          setup: {
            maxServices: { enabled: true, value: 10 },
            engineBInfo: { enabled: true }
          }
        }
      }
    },
    [AGENT_MODEL.VTA]: {
      setup: {
        engineBInfo: { enabled: true }
      },
      modes: {
        [TestMode.MA_TO_MA]: {
          setup: {
            maxServices: { enabled: true, value: 10 }
          }
        }
      },
      versions: {
        /* if vta has newer versions then the differences can be put here */
        '2.0': {
          setup: {},
          running: {},
          final: {}
        }
      }
    },
    [AGENT_MODEL.VSPA_SAT]: {
      setup: {
        engineBInfo: { enabled: true }
      },
      modes: {
        [TestMode.MA_TO_MA]: {
          setup: {
            maxServices: { enabled: true, value: 10 }
          }
        }
      },
      versions: {
        /* if vta has newer versions then the differences can be put here */
        '2.0': {
          setup: {},
          running: {},
          final: {}
        }
      }
    }
  }
};
